<template>
    <v-container fill-height class="d-flex align-center justify-center">
      <v-card class="pa-5 login-card">
        <v-card-title class="headline text-center">Вход в систему</v-card-title>
        <v-card-subtitle class="text-center">(c) Qpark.IO</v-card-subtitle>
  
        <v-form @submit.prevent="login">
          <v-text-field
            v-model="username"
            label="Логин"
            prepend-inner-icon="mdi-account"
            outlined
            required
            :disabled="loading"
          ></v-text-field>
  
          <v-text-field
            v-model="password"
            label="Пароль"
            :type="showPassword ? 'text' : 'password'"
            prepend-inner-icon="mdi-lock"
            outlined
            required
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="showPassword = !showPassword"
            :disabled="loading"
          ></v-text-field>
  
          <v-btn block color="primary" class="mt-3" type="submit" :loading="loading">
            Войти
          </v-btn>
        </v-form>
  
        <v-alert v-if="error" type="error" dense class="mt-3">
          {{ error }}
        </v-alert>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    name: "AdminLogin",
    data() {
      return {
        username: "",
        password: "",
        showPassword: false,
        error: "",
        loading: false, // ✅ Индикация загрузки
      };
    },
    methods: {
      async login() {
        this.error = "";  // ✅ Очищаем ошибку
        this.loading = true;  // ✅ Включаем спиннер
  
        try {
          const response = await axios.post(
            "https://geonode.qpark.io/api/login",
            {
              username: this.username,
              password: this.password, // ❗️Если оставляешь SHA2 в БД, надо передавать уже хешированный пароль
            },
            { withCredentials: true } // ✅ Нужно для передачи сессий и токенов через CORS
          );
  
          if (response.data.success) {
            localStorage.setItem("token", response.data.token);
            this.$emit("login");
          } else {
            this.error = "Неверный логин или пароль";
            this.resetForm();
          }
        } catch (error) {
          this.error = "Ошибка сервера";
          console.error(error);
          this.resetForm();
        } finally {
          this.loading = false; // ✅ Выключаем спиннер
        }
      },
      resetForm() {
        this.username = "";
        this.password = "";
      },
    },
  };
  </script>
  
  <style scoped>
  .login-card {
    width: 400px;
    max-width: 90%;
    border-radius: 12px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  </style>
  